import React from 'react';
import { AccessibleSelect } from '../../common';
import { RtModal, RtModalField, RtModalSection } from '../../ui/RtModal';

const PROJECT_NAME_MAX_LENGTH = 50;

const PROJECT_TYPE_OPTIONS = [
  { value: 'WEB', label: 'Web' },
  { value: 'MOBILE', label: 'Mobile' },
  { value: 'DESKTOP', label: 'Desktop' },
  { value: 'API_BACKEND', label: 'ApiBackend' },
  { value: 'EMBEDDED', label: 'Embedded' },
  { value: 'CLOUD_DEVOPS', label: 'CloudDevOps' },
];

const CreateProjectModal = ({
  toggleCreateProjectModal,
  projectName,
  setProjectName,
  projectDescription,
  setProjectDescription,
  projectType,
  setProjectType,
  handleCreateProject,
  loading,
}) => {
  const nameTooLong = projectName.length > PROJECT_NAME_MAX_LENGTH;
  const close = () => {
    if (!loading) toggleCreateProjectModal();
  };

  return (
    <RtModal
      open
      onClose={close}
      title="Create New Project"
      subtitle="Set up a new project workspace"
      size="md"
      closeDisabled={loading}
      closeOnBackdrop={!loading}
      footer={
        <>
          <button type="button" className="rt-btn rt-btn--secondary" onClick={close} disabled={loading}>
            Cancel
          </button>
          <button
            type="submit"
            form="rt-create-project-form"
            className="rt-btn rt-btn--primary"
            disabled={loading || !projectName || !projectType || nameTooLong}
          >
            {loading ? 'Creating…' : 'Create Project'}
          </button>
        </>
      }
    >
      <form
        id="rt-create-project-form"
        onSubmit={(e) => {
          e.preventDefault();
          if (!loading && projectName && projectType && !nameTooLong) {
            handleCreateProject();
          }
        }}
      >
        <RtModalSection title="Basic information">
          <RtModalField
            label="Project name"
            htmlFor="projectName"
            required
            error={
              nameTooLong
                ? `Project Name cannot exceed ${PROJECT_NAME_MAX_LENGTH} characters.`
                : null
            }
            hint={!nameTooLong ? `Maximum ${PROJECT_NAME_MAX_LENGTH} characters.` : null}
          >
            <input
              type="text"
              id="projectName"
              value={projectName}
              onChange={(e) => setProjectName(e.target.value)}
              required
              maxLength={52}
              placeholder="e.g. Payment Service"
              disabled={loading}
            />
          </RtModalField>

          <RtModalField label="Description" htmlFor="projectDescription">
            <textarea
              id="projectDescription"
              value={projectDescription}
              onChange={(e) => setProjectDescription(e.target.value)}
              rows={3}
              placeholder="Brief description about the project"
              disabled={loading}
            />
          </RtModalField>
        </RtModalSection>

        <RtModalSection title="Settings">
          <RtModalField label="Project type" htmlFor="projectType" required>
            <AccessibleSelect
              id="projectType"
              value={projectType}
              onChange={setProjectType}
              options={PROJECT_TYPE_OPTIONS}
              placeholder="Select Type"
              required
              disabled={loading}
              aria-labelledby="projectType-label"
            />
          </RtModalField>
        </RtModalSection>
      </form>
    </RtModal>
  );
};

export default CreateProjectModal;
